import { useSubscriptionStatus } from '@/hooks/useSubscriptionStatus';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useState } from 'react';

export function SoftCloseBanner() {
  const { profile } = useAuth();
  const { data: subscriptionStatus } = useSubscriptionStatus();
  const [loading, setLoading] = useState(false);
  const isSuperAdmin = profile?.is_super_admin === true;
  const isSoftClosed = subscriptionStatus?.status === 'soft_closed';

  if (!isSoftClosed || isSuperAdmin) return null;

  async function handleReactivate() {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('create-reactivation-checkout-session');
      if (error || !data?.url) throw error ?? new Error('No checkout URL');
      window.location.href = data.url;
    } catch {
      setLoading(false);
    }
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 text-sm flex items-center justify-between gap-4 z-[9998] relative">
      <span className="text-amber-900 font-medium">
        Your subscription has ended. Your records are safe — you have read-only access to all your policies and audit exports.
      </span>
      <button
        onClick={handleReactivate}
        disabled={loading}
        className="shrink-0 bg-amber-600 hover:bg-amber-700 disabled:opacity-50 text-white text-sm font-semibold px-4 py-1.5 rounded-md transition-colors"
      >
        {loading ? 'Loading…' : 'Reactivate'}
      </button>
    </div>
  );
}
